import React, {type ReactNode} from 'react'
import logo from './../../../images/duesy-logo.svg'
import logoLight from './../../../images/duesy-logo-light.svg'
import classNames from '@/Utils/ClassNames'

interface LogoProps {
    size?: number
    classes?: string[]
}

export default function Logo(
    {
        size,
        classes,
    }: LogoProps): ReactNode {
    const [width,] = React.useState<number>(size ?? 39)

    const className = (): string => {
        const list = []

        if (classes) {
            list.push(...classes)
        }

        list.push(size ? `w-[${size}px]` : 'w-[39px]')

        return list.join(' ')
    }

    const title: string = 'Duesy'
    const alt: string = 'Duesy'

    return (
        <div className={classNames(className())}>
            <img
                src={logo}
                title={title}
                alt={alt}
                className={'dark:hidden'}
                style={{width: `${width}px`, height: `${width}px`}}
            />
            <img
                src={logoLight}
                title={title}
                alt={alt}
                className={'hidden dark:block'}
            />
        </div>
    )
}
